'use strict';

// сохранить в памяти выбранное животное
export function SetGlobalAnimal(animal)
{ 
    localStorage.setItem('animal_ID', animal.ID);
    localStorage.setItem('animal_name', animal.animal_name);
    localStorage.setItem('animal_sex', animal.animal_sex.value);
    localStorage.setItem('animal_sex_label', animal.animal_sex.label);
    localStorage.setItem('animal_born', animal.animal_born);
    localStorage.setItem('animal_weight', animal.animal_weight);
    localStorage.setItem('animal_type', animal.animal_type.value);
    localStorage.setItem('animal_type_label', animal.animal_type.label);
}
export function GetGlobalAnimal()
{ 
    var animal = [];
    animal.animal_sex = [];
    animal.animal_type = [];
    animal.ID = localStorage.getItem('animal_ID');
    animal.animal_name = localStorage.getItem('animal_name');
    animal.animal_sex.value = localStorage.getItem('animal_sex');
    animal.animal_sex.label = localStorage.getItem('animal_sex_label');
    animal.animal_born = localStorage.getItem('animal_born');
    animal.animal_weight = localStorage.getItem('animal_weight');
    animal.animal_type.value = localStorage.getItem('animal_type');
    animal.animal_type.label = localStorage.getItem('animal_type_label');

    if(animal.animal_name === undefined || animal.animal_name == null || animal.animal_name == null) animal.animal_name = "";
    if(animal.animal_type === undefined || animal.animal_type == null || animal.animal_type == null) animal.animal_type = "";
    return animal;
}
export function ClearGlobalAnimal()
{ 
    localStorage.removeItem('animal_ID');
    localStorage.removeItem('animal_name');
    localStorage.removeItem('animal_sex');
    localStorage.removeItem('animal_sex_label');
    localStorage.removeItem('animal_born');
    localStorage.removeItem('animal_weight');
    localStorage.removeItem('animal_type');
    localStorage.removeItem('animal_type_label');
}

// преобразовать данные полученные из БД в объект animal
export function ToAnimal(data)
{
    var animal = [];
    animal.animal_sex = [];
    animal.animal_type = [];
    animal.ID = data.ID;
    animal.animal_name = data.animal_name;
    animal.animal_sex.value = data.ID_animal_sex;
    animal.animal_sex.label = data.animal_sex;
    animal.animal_born = data.born;
    animal.animal_weight = data.weight;
    animal.animal_type.value = data.ID_animal_type;
    animal.animal_type.label = data.animal_type;
    return animal;
}

export default SetGlobalAnimal;